var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMenuHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 2C2.48937 2 2 2.46755 2 3C2 3.53245 2.48937 4 3 4H4H17V2H3ZM3 0C1.42454 0 0 1.32365 0 3V18.0612C0 18.8996 0.080099 19.8542 0.502782 20.6216C0.726493 21.0278 1.04982 21.3891 1.49938 21.6412C1.94425 21.8907 2.45294 22 3 22H23V16.5H24V10H23V4H19V0H3ZM21 10V6H4H3H2.875C2.5656 6 2.27241 5.94797 2 5.85383V18.0612C2 18.8458 2.09153 19.3606 2.25466 19.6568C2.32385 19.7824 2.39697 19.8516 2.47773 19.8969C2.56319 19.9448 2.71869 20 3 20H21V16.5H17.25C15.455 16.5 14 15.045 14 13.25C14 11.455 15.455 10 17.25 10H21ZM16 13.25C16 12.5595 16.5595 12 17.25 12H22V14.5H17.25C16.5595 14.5 16 13.9405 16 13.25Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuHome);
export default __webpack_public_path__ + "static/media/icon_menu_home.76579dbc.svg";
export { ForwardRef as ReactComponent };